import { ImageIcon, Loader2 } from 'lucide-react';
import { useAuthedBlob } from '@/api/useAuthedBlob';

/**
 * Authed thumbnail preview for a review candidate.
 *
 * The generated `getEffectPackThumbnail` fetcher is typed to return `string`, which corrupts the
 * binary PNG response body. CMP parity: `EffectPackReviewViewModel.loadThumbnailBytes` pulls raw
 * bytes through the authed HttpClient because a bearer token cannot ride a plain <img>/AsyncImage
 * URL — so here we fetch the same endpoint as a blob (via `useAuthedBlob`, which attaches auth
 * through the shared `http` axios instance) and render it as an object URL instead.
 */
export function EffectPackThumbnail({ id }: { id: string }) {
  const { src, isLoading } = useAuthedBlob(`/admin/api/effect-packs/thumbnails/${id}.png`);

  return (
    <div className="flex size-24 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-muted">
      {src ? (
        <img src={src} alt="" className="size-full object-cover" />
      ) : isLoading ? (
        <Loader2 className="size-5 animate-spin text-muted-foreground" />
      ) : (
        <ImageIcon className="size-6 text-muted-foreground" />
      )}
    </div>
  );
}
